import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,

  itemsSelected: [],
  functions: []
};

const slice = createSlice({
  name: 'selectCreate',
  initialState,
  reducers: {
    // functions

    getSelectCreateFuncs(state, action) {
      const funcs = action.payload;
      const findedFunc = state.functions.find((fun) => fun.selectCreateId === funcs.selectCreateId);

      if (!findedFunc) {
        state.functions = [...state.functions, funcs];
      }
    },

    resetSelectCreateFunctions(state) {
      state.functions = [];
    },

    // getDialogItemListFunc(state, action) {
    //   const func = action.payload;
    //   state.functions.dialogItemListHandler = func;
    // },

    // getDialogItemCreateFunc(state, action) {
    //   const func = action.payload;
    //   state.functions.dialogItemCreateHandler = func;
    // },

    // select item
    selectItem(state, action) {
      const item = action.payload;
      const filtered = state.itemsSelected.filter((it) => it.selectCreateId !== item.selectCreateId);
      state.itemsSelected = [...filtered, item];
    },

    // remove item
    removeItem(state, action) {
      const selectCreateId = action.payload;
      const filtered = state.itemsSelected.filter((it) => it.selectCreateId !== selectCreateId);
      state.itemsSelected = [...filtered];
    },

    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

export const {
  selectItem,
  removeItem,
  getDialogItemListFunc,
  getDialogItemCreateFunc,
  getSelectCreateFuncs,
  resetSelectCreateFunctions
} = slice.actions;

// ----------------------------------------------------------------------

// export const selectItemAction = (item) => (dispatch) => {
//   console.log('action', item);
//   // dispatch(selectItemAction(item));
// };

export function getDialogItemListFuncAction(func) {
  return (dispatch) => {
    dispatch(getDialogItemListFunc(func));
  };
}

export function getDialogItemCreateFuncAction(func) {
  return (dispatch) => {
    dispatch(getDialogItemCreateFunc(func));
  };
}

export function selectItemAction(item) {
  return (dispatch) => {
    dispatch(selectItem(item));
  };
}

export function removeItemAction(selectCreateId) {
  return (dispatch) => {
    dispatch(removeItem(selectCreateId));
  };
}

export function getLabels() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/mail/labels');
      dispatch(slice.actions.getLabelsSuccess(response.data.labels));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
